<template>
  <div class="item" v-if="GoodsItem">
    <rl-img :src="GoodsItem.photoUrl" width="100%" height="300px"></rl-img>
    <div class="title">
      <span v-if="GoodsItem.name">{{GoodsItem.name}}</span>
      <span v-else style="color: gray">Title</span>
    </div>
    <div class="bottom">
      <div class="number1">
        <span v-if="GoodsItem.modelNumber">{{GoodsItem.modelNumber}}</span>
        <span v-else>modelNumber</span>
      </div>
      <span @click="DetailTo(GoodsItem.id)">查看更多<i class="el-icon-arrow-right"></i> </span>
    </div>
  </div>
</template>

<script>
import RlImg from "@/components/img/img";
export default {
  name: "GoodsItem",
  components: {RlImg},
  props:{
    GoodsItem:{}
  },
  methods:{
    DetailTo(id){
      this.$router.push('/product/detail/'+id)
    }
  }
}
</script>

<style lang="less" scoped>
.item{
  width: 270px;
  height: 375px;
  min-width: 250px;
  min-height: 375px;
  border-radius: 4px;
  border: 1px solid #DDDDDD;
  margin: 5px 5px 5px 0;
  .title{
    padding-left: 5px;
    padding-bottom: 8px;
    height: 30px;
    span{
      height: 20px;
      font-size: 20px;
      font-family: SourceHanSansCN-Bold, SourceHanSansCN;
      font-weight: bold;
      color: #333333;
      line-height: 30px;
    }
  }
  .bottom{
    display: flex;
    justify-content: space-between;
    padding: 10px 5px 0 5px;
    span{
      &:first-child{
        height: 14px;
        font-size: 14px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #666666;
        line-height: 21px;
      }
      &:last-child{
        height: 16px;
        font-size: 16px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #999999;
        line-height: 21px;
        &:hover{
          color: #188ACB;
        }
      }
    }
  }
}
</style>